import { render, staticRenderFns } from "./HealthSelfDeclaration.vue?vue&type=template&id=9e0af2ba&scoped=true&"
import script from "./HealthSelfDeclaration.vue?vue&type=script&lang=js&"
export * from "./HealthSelfDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./HealthSelfDeclaration.scss?vue&type=style&index=0&id=9e0af2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0af2ba",
  null
  
)

export default component.exports